import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { bankService } from 'services';

// const companiesAdapter = createEntityAdapter({
//   // Assume IDs are stored in a field other than `book.id`
//   selectId: (company) => company.company_id,
//   // Keep the "all IDs" array sorted based on book titles
//   sortComparer: (a, b) => a.company_name.localeCompare(b.company_name),
// });

const slice = createSlice({
  name: 'banks',
  // initialState: booksAdapter.getInitialState(),
  initialState: { ids: [], entities: {}, dirty: true },
  reducers: {
    setBusy(state, action) {
      state.busy = action.payload;
    },
    add(state, action) {
      const { resData } = action.payload;

      //TODO : review - temp assuming flush true
      // const flush = action.payload.flush || true;
      const flush = true;

      let existingData = state.entities || {};
      let existingIds = state.ids || [];

      let entities = {
        ...existingData,
      };

      let ids = existingIds.concat([]);

      if (flush) {
        entities = {};
        ids = [];
      }

      // debugger;
      _.each(resData, (item, id) => {
        if (parseInt(id)) {
          entities[id] = {
            // isListLoaded: true,
            ...(entities[id] || {}),
            ...item,
          };
          if (!ids.includes(id)) {
            ids.push(id);
          }
        }
      });

      state['entities'] = entities;
      state['ids'] = ids;
      state['dirty'] = false;
      state['updatedAt'] = Date.now();

      // state.fetching = false;
    },
    setDirty(state, action) {
      state = { ids: [], entities: {}, dirty: true };
      return state;
    },
  },
});

const fetchList = () => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await bankService.fetchList();
    dispatch(
      slice.actions.add({
        resData: resData,
      }),
    );
  } catch (err) {
    dispatch(
      slice.actions.add({
        resData: {},
      }),
    );
    console.log('Redux-banks->fetchList-->Err', err);
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchList,
};

const selectors = {
  // selectLoader,
};

export { actions, selectors };

export default slice.reducer;
